import ReactMarkdown from 'react-markdown';
import React from "react";

// custom imports
import logo from '../public/assets/safir-long.svg'
import background from '../public/bg.jpg'

// import markdown files
import intro from '../markdown/intro.md'
import governance from '../markdown/governance.md'
import whitepaper from '../markdown/whitepaper.md'
import projects from '../markdown/projects.md'
import token from '../markdown/token.md'
import exchanges from '../markdown/exchanges.md'
import explorer from '../markdown/explorer.md'


// sidebar consists out of categories which each contain elements which contain
export const sidebar = [
    {
        name: 'SGI Tokens',
        elements: [
            {
                name: 'introduction',
                content: <ReactMarkdown>{intro}</ReactMarkdown>
            },
            {
                name: 'the SGI token',
                content: <ReactMarkdown>{token}</ReactMarkdown>
            },
        ]
    },
    {
        name: 'ecosystem',
        elements: [
            {
                name: 'projects',
                content: <ReactMarkdown>{projects}</ReactMarkdown>
            },
            {
                name: 'exchanges',
                content: <ReactMarkdown>{exchanges}</ReactMarkdown>
            },
            {
                name: 'explorer',
                content: <ReactMarkdown>{explorer}</ReactMarkdown>
            },
        ]
    },
    {
        name: 'governance',
        elements: [
            {
                name: 'governance',
                content: <ReactMarkdown>{governance}</ReactMarkdown>
            },
        ]
    },
    {
        name: 'documents',
        elements: [
            {
                name: 'whitepaper',
                content: <ReactMarkdown>{whitepaper}</ReactMarkdown>
            },
        ]
    },
]

// customize
// export const modular = {
//     logo: logo,
//     mainColor: 'rgb(6,13,51)',
//     footer: <>
//         <div>© 2023 Safir Group International</div>
//         <div>DAO LLC - All rights reserved.</div></>,
//     background: background
//
// }
export const modular = {
    title: 'SGI',
    logo: logo,
    mainColor: 'rgb(7, 17, 61)',
    footer: <>
        <div>© 2023 Safir Group International</div>
        <div>DAO LLC - All rights reserved.</div>
    </>,
    background: background,
    // headerButton: {
    //         text: 'Check out SAFIR',
    //         link: 'https://www.safir.com',
    //         color: 'white',
    //         hoverColor: 'black',
    // },
    //black = true and white = false
    mobileMenuButtonColor: false

}
